import React from 'react';

export default function AjaxSpinner({type})
{
    return (
        <div className={type === 'inline' ? 'loading-wrapper-mini' : 'loading-wrapper'}>
            <div className="loader">Loading...</div>
        </div>
    );
};